/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from 'react'
import * as PropTypes from 'prop-types'
import { FormControl, Typography, IconButton } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './View.Style'
import CheckboxItem from './checkbox_item/View'

const CheckboxSelector = props => {
  const {
    classes,
    items,
    helpText,
    subItemsKey,
    linkName,
    subLinkName,
    values,
    onValueChange,
    navigateTo,
    error,
    reference,
  } = props
  const [isSubItemsExpanded, setSubItemsExpanded] = React.useState({})

  return (
    <Fragment>
      <div className={classes.root} ref={reference}>
        <div>
          {helpText ? (<p>{helpText}</p>) : (<p className={classes.errorMessage}/>)}
          {error && <p className={classes.errorMessage}>{error}</p>}
        </div>
        <div className={classes.inputContainer}>
          <FormControl component="fieldset">
            {items.map(item => {
              if (subItemsKey && item[subItemsKey]) {
                return (
                  <Fragment key={item.name}>
                    <IconButton
                      className={isSubItemsExpanded[item.name] ? 'icon-less' : 'icon-more'}
                      classes={{ root: classes.expandButton }}
                      onClick={() => {
                        setSubItemsExpanded({ [item.name]: !isSubItemsExpanded[item.name] })
                      }}
                      disableRipple
                    >
                      <Typography classes={{ root: classes.itemName }}>{item.name}</Typography>
                    </IconButton>
                    {isSubItemsExpanded[item.name] &&
                      item[subItemsKey].map(subItem => (
                        <CheckboxItem
                          classes={{ marginLeft: classes.marginLeft }}
                          key={subItem.id.toString}
                          item={subItem}
                          name={subItem.id}
                          linkName={subLinkName}
                          navigateTo={navigateTo}
                          onCheckboxClick={event => onValueChange(event.target)}
                          isChecked={values.includes(subItem.id)}
                        />
                      ))}
                  </Fragment>
                )
              }
              return (
                <CheckboxItem
                  key={item.id}
                  name={item.id}
                  item={item}
                  linkName={linkName}
                  navigateTo={navigateTo}
                  onCheckboxClick={event => onValueChange(event.target)}
                  isChecked={values.includes(item.id)}
                />
              )
            })}
          </FormControl>
        </div>
      </div>
    </Fragment>
  )
}

CheckboxSelector.defaultProps = {
  helpText: '',
  subItemsKey: '',
  linkName: '',
  subLinkName: '',
  values: [],
  navigateTo: null,
  error: '',
  reference: null,
}

CheckboxSelector.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    group: PropTypes.string,
    radioNotChecked: PropTypes.string,
    radioLabelWithLink: PropTypes.string,
    radioLabel: PropTypes.string,
    marginLeft: PropTypes.string,
    itemName: PropTypes.string,
    expandButton: PropTypes.string,
    inputContainer: PropTypes.string,
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  helpText: PropTypes.string,
  subItemsKey: PropTypes.string,
  linkName: PropTypes.string,
  subLinkName: PropTypes.string,
  values: PropTypes.array,
  onValueChange: PropTypes.func.isRequired,
  navigateTo: PropTypes.func,
  error: PropTypes.string,
  reference: PropTypes.shape({}),
}

export default withStyles(styles)(CheckboxSelector)
